import React, { useEffect } from "react"
import { ReportProblemOutlined as WarningIcon } from "@material-ui/icons"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import { ChannelType } from "@/protocols/channel"

import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"
import BlockBodySectionRequiredCondition from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"

import HardCoded from "@/services/HardCoded"

import {
	getConditionRuleByValidationSlug
} from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"
import { generateUUID } from "@/utils/id"

type MessageSendFailedConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	chatBotFlowBlockId: number
	chatBotFlowChannelType: ChannelType
}

const MESSAGE_SEND_FAILED_VALIDATION_SLUG = "message-send-failed"

const MessageSendFailedConditionSection: React.FC<MessageSendFailedConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		chatBotFlowBlockId,
		chatBotFlowChannelType
	} = props

	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId })

	const messageSendFailedRule = getConditionRuleByValidationSlug(
		MESSAGE_SEND_FAILED_VALIDATION_SLUG,
		nextChatBotFlowBlockRules
	)

	const isWabaChannel = chatBotFlowChannelType === "waba"
	const isBotFlowWABAErrorOutputEnabled = HardCoded.checkFeatureFlag("canUseBotFlowWABAErrorOutput")
	const shouldAutoCreateRule = isWabaChannel && isBotFlowWABAErrorOutputEnabled && !messageSendFailedRule
	const shouldCleanupRule = !isBotFlowWABAErrorOutputEnabled && Boolean(messageSendFailedRule)

	useEffect(() => {
		if (shouldCleanupRule && messageSendFailedRule) {
			chatBotFlowBlockDetails.changeRule("DELETE", messageSendFailedRule)
		}
	}, [shouldCleanupRule, messageSendFailedRule?.id])

	useEffect(() => {
		if (!shouldAutoCreateRule) {
			return
		}

		chatBotFlowBlockDetails.changeRule("CREATE", {
			logic: "and",
			category: "exit-condition",
			id: generateUUID(),
			next_chat_bot_flow_block_id: null,
			validations: [
				{
					slug: MESSAGE_SEND_FAILED_VALIDATION_SLUG,
					first_param: "{{wasMessageSendFailed}}",
					second_param: null,
					type: "exists"
				}
			]
		})
	}, [shouldAutoCreateRule, chatBotFlowBlockId])

	if (!isWabaChannel || !isBotFlowWABAErrorOutputEnabled || !messageSendFailedRule) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle chatBotFlowBlockRule={messageSendFailedRule}>
				<BlockBodySectionRequiredCondition
					text="Próximo passo se a mensagem falhar"
					icon={<WarningIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default MessageSendFailedConditionSection
